import React from 'react';
import PropTypes from 'prop-types';
import removeInvalidHtmlChars from 'common/App/removeInvalidHtmlChars';
import BeneficialOwner from './beneficialOwner';

const StatementAllocationErrorsBlock = ({ structure, decimalPrecision }) => (
  <div>
    {structure && structure?.recipients && structure?.recipients.length > 0 && (
    <div className="allocation-errors-container" data-testid="allocation-errors">
      {BeneficialOwner.getAllocationErrors(structure, decimalPrecision).map((row, index) => (
        <div key={ row.id } className="allocation-error-container" data-testid={ removeInvalidHtmlChars(`allocation-error-${ row.id }`) }>
          <div>{row.errorOwner}</div>
          <div>{row.errorType}:</div>
          <div className="allocation-error-value">{row.errorValue}%</div>
        </div>
      ))}
    </div>
    )}
  </div>
);

StatementAllocationErrorsBlock.propTypes = {
  structure: PropTypes.shape({
    recipients: PropTypes.arrayOf(PropTypes.shape())
  }),
  decimalPrecision: PropTypes.number.isRequired
};

StatementAllocationErrorsBlock.defaultProps = {
  structure: null
};

export default StatementAllocationErrorsBlock;
